import './style/index.less';
import Role from './Role';

export default Role;
